module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "cards-view"
  }, [_c('Card', [_c('CardHead', {
    attrs: {
      "link": "#",
      "title": "萌宠保卫战",
      "img": "https://imgly.net/img/2gj.jpg"
    },
    slot: "head"
  }), _vm._v(" "), _c('CardLink', {
    attrs: {
      "link": "#",
      "title": "如何喂食",
      "img": "https://imgly.net/img/2gj.jpg"
    },
    slot: "link"
  }), _vm._v(" "), _c('CardLink', {
    attrs: {
      "link": "#",
      "title": "如何铲屎",
      "img": "https://imgly.net/img/2gj.jpg"
    },
    slot: "link"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-e5a26b08!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/cardsView.vue
// module id = 289
// module chunks = 0